/**
 * Design System Components Export
 *
 * Central export file for all design system components
 */

export { WebAppShell, invalidateSidebarRecentDocumentsCache } from './WebAppShell';
export { PageHeader } from './PageHeader';
